import ApplicationListItemContainer from './application_list_item_container';

const ApplicationListItem = ApplicationListItemContainer;
export default ApplicationListItem;
